<template>
	<article class="website-dev">
		<h1>Website Development</h1>
		<div class="content">

			<p>
				We provide customized web-based solutions tailored to the client’s specific business requirements using the latest technologies and industry trends.
			</p>

			<!-- ================================================= -->
			<!-- Why a Website is a worthwhile business investment -->
			<!-- ================================================= -->
			<h3 @click="toggleCollapse('collapseA')" class="collapse-link">
				<span class="glyphicon glyphicon-chevron-right" v-show="!collapseA"></span>
				<span class="glyphicon glyphicon-chevron-down" v-show="collapseA"></span>
				Why a Website is a worthwhile business investment
			</h3>
			<div v-show="collapseA" class="collapse-container">
				<ul class="media-list icon-list">
					<li class="media media-success media-default">
						<div class="media-left">
							<a class="btn btn-success btn-lg btn-circle">
								<!--<span class="glyphicon glyphicon-ok"></span>-->
								<span class="glyphicon glyphicon glyphicon-globe"></span>
							</a>
						</div>
						<div class="media-body">
							<h4 class="media-heading">Reach a wider audience regardless of geographical location.</h4>
						</div>
					</li>
					<li class="media media-success media-default">
						<div class="media-left">
							<a class="btn btn-success btn-lg btn-circle">
								<!--<span class="glyphicon glyphicon-ok"></span>-->
								<span class="glyphicon glyphicon-sunglasses"></span>
							</a>
						</div>
						<div class="media-body">
							<h4 class="media-heading">Creates a professional look for your brand.</h4>
						</div>
					</li>
					<li class="media media-success media-default">
						<div class="media-left">
							<a class="btn btn-success btn-lg btn-circle">
								<!--<span class="glyphicon glyphicon-ok"></span>-->
								<span class="glyphicon glyphicon-repeat"></span>
							</a>
						</div>
						<div class="media-body">
							<h4 class="media-heading">Saves you time answering the same questions over and over again.</h4>
						</div>
					</li>
					<li class="media media-success media-default">
						<div class="media-left">
							<a class="btn btn-success btn-lg btn-circle">
								<!--<span class="glyphicon glyphicon-ok"></span>-->
								<span class="glyphicon glyphicon-time"></span>
							</a>
						</div>
						<div class="media-body">
							<h4 class="media-heading">Accessible around the clock 24/7.</h4>
						</div>
					</li>
				</ul>
				<div class="spacing10"></div>
				<p>
					Let us help you develop an efficient website solution for your business.
				</p>
				<div class="spacing30"></div>
			</div>

			<!-- =========================== -->
			<!-- Website Development Process -->
			<!-- =========================== -->
			<h3 @click="toggleCollapse('collapseB')"  class="collapse-link">
				<span class="glyphicon glyphicon-chevron-right" v-show="!collapseB"></span>
				<span class="glyphicon glyphicon-chevron-down" v-show="collapseB"></span>
				Website Development Process
			</h3>
			<div v-show="collapseB"  class="collapse-container">
				<ul class="media-list icon-list">
					<li class="media media-primary media-default">
						<div class="media-left">
							<a class="btn btn-primary-invert btn-lg btn-circle">
								<span class="customicon">1</span>
							</a>
						</div>
						<div class="media-body">
							<h4 class="media-heading">Information Gathering</h4>
							<ul>
								<li>Purpose</li><li>Goals</li>
								<li>Target Audience</li>
								<li>Content</li>
							</ul>
						</div>
					</li>
					<li class="media media-primary media-default">
						<div class="media-left">
							<a class="btn btn-primary-invert btn-lg btn-circle">
								<span class="customicon">2</span>
							</a>
						</div>
						<div class="media-body">
							<h4 class="media-heading">Planning</h4>
							<ul>
								<li>Research</li>
								<li>Analyze</li>
								<li>Technologies</li>
							</ul>
						</div>
					</li>
					<li class="media media-primary media-default">
						<div class="media-left">
							<a class="btn btn-primary-invert btn-lg btn-circle">
								<span class="customicon">3</span>
							</a>
						</div>
						<div class="media-body">
							<h4 class="media-heading">Design</h4>
							<ul>
								<li>Look and Feel</li>
								<li>Responsive Design</li>
							</ul>
						</div>
					</li>
					<li class="media media-primary media-default">
						<div class="media-left">
							<a class="btn btn-primary-invert btn-lg btn-circle">
								<span class="customicon">4</span>
							</a>
						</div>
						<div class="media-body">
							<h4 class="media-heading">Development</h4>
							<ul>
								<li>Custom Web Development</li>
								<li>CMS (Content Management System)</li>
								<li>Documentation</li>
							</ul>
						</div>
					</li>
					<li class="media media-primary media-default">
						<div class="media-left">
							<a class="btn btn-primary-invert btn-lg btn-circle">
								<span class="customicon">5</span>
							</a>
						</div>
						<div class="media-body">
							<h4 class="media-heading">Testing</h4>
							<ul>
								<li>General Testing</li>
								<li>Usability Testing</li>
								<li>Performance Profiling</li>
							</ul>
						</div>
					</li>
					<li class="media media-primary media-default">
						<div class="media-left">
							<a class="btn btn-primary-invert btn-lg btn-circle">
								<span class="customicon">6</span>
							</a>
						</div>
						<div class="media-body">
							<h4 class="media-heading">Acceptance and Deployment</h4>
							<ul>
								<li>Review and Approval</li>
								<li>Launch</li>
							</ul>
						</div>
					</li>
					<li class="media media-primary media-default">
						<div class="media-left">
							<a class="btn btn-primary-invert btn-lg btn-circle">
								<span class="customicon">7</span>
							</a>
						</div>
						<div class="media-body">
							<h4 class="media-heading">Maintenance</h4>
							<ul>
								<li>Management</li>
								<li>SEO (Search Engine Optimization)</li>
							</ul>
						</div>
					</li>
				</ul>
				<div class="spacing10"></div>
				<p>
					We deliver fast and effective website solutions.
				</p>
				<div class="spacing30"></div>
			</div>

			<!-- ================ -->
			<!-- Our Websites Are -->
			<!-- ================ -->
			<h3 @click="toggleCollapse('collapseC')" class="collapse-link">
				<span class="glyphicon glyphicon-chevron-right" v-show="!collapseC"></span>
				<span class="glyphicon glyphicon-chevron-down" v-show="collapseC"></span>
				Why our websites are the right solution for you
			</h3>
			<div v-show="collapseC" class="collapse-container">
				<ul class="media-list icon-list">
					<li class="media media-success media-default">
						<div class="media-left">
							<a class="btn btn-success btn-lg btn-circle">
								<!--<span class="glyphicon glyphicon-ok"></span>-->
								<span class="glyphicon glyphicon-user"></span>
							</a>
						</div>
						<div class="media-body">
							<h4 class="media-heading">User Friendly.</h4>
						</div>
					</li>
					<li class="media media-success media-default">
						<div class="media-left">
							<a class="btn btn-success btn-lg btn-circle">
								<!--<span class="glyphicon glyphicon-ok"></span>-->
								<span class="glyphicon glyphicon-cog"></span>
							</a>
						</div>
						<div class="media-body">
							<h4 class="media-heading">Easily Manageable.</h4>
						</div>
					</li>
					<li class="media media-success media-default">
						<div class="media-left">
							<a class="btn btn-success btn-lg btn-circle">
								<!--<span class="glyphicon glyphicon-ok"></span>-->
								<span class="glyphicon glyphicon-search"></span>
							</a>
						</div>
						<div class="media-body">
							<h4 class="media-heading">Search Engine Friendly.</h4>
						</div>
					</li>
					<li class="media media-success media-default">
						<div class="media-left">
							<a class="btn btn-success btn-lg btn-circle">
								<!--<span class="glyphicon glyphicon-ok"></span>-->
								<span class="glyphicon glyphicon-phone"></span>
							</a>
						</div>
						<div class="media-body">
							<h4 class="media-heading">Responsive with a multi-device friendly approach.</h4>
						</div>
					</li>
					<li class="media media-success media-default">
						<div class="media-left">
							<a class="btn btn-success btn-lg btn-circle">
								<!--<span class="glyphicon glyphicon-ok"></span>-->
								<span class="glyphicon glyphicon-heart"></span>
							</a>
						</div>
						<div class="media-body">
							<h4 class="media-heading">Customized to the client’s specific needs.</h4>
						</div>
					</li>
				</ul>
				<div class="spacing10"></div>
				<p>
					We makes websites that are simple to update and customized for each client’s specific needs.
				</p>
			</div>

		</div>

	</article>
</template>

<script>
	export default {
		name: 'websiteDevelopment',
		methods: {
		    toggleCollapse (collapse) {
		        if (collapse) {
					this[collapse] = !this[collapse]
				}
			}
		},
		data () {
			return {
			    collapseA: false,
				collapseB: false,
				collapseC: false
			}
		}
	}
</script>

<style scoped>
	.website-dev .content h3 { cursor:pointer; }

	.website-dev .media-list .media { padding:15px; background: #e5e5e5; }
	/*.website-dev .media-list .media:not(:last-child) { border-bottom:1px solid #ccc; padding-bottom:15px; }*/
	.website-dev .media-list .media-left { padding-right:15px; border-right:2px solid #ccc; }
	.website-dev .media-list .media-left .btn { position:relative; width:40px; height:40px; }
	.website-dev .media-list .media-left .btn .customicon,
	.website-dev .media-list .media-left .btn .glyphicon { position:absolute; top:50%; left:50%; transform: translate(-50%, -50%); font-size: 20px; }
	.website-dev .media-list .media-body { padding-left:15px; }
	.website-dev .media-list .media-heading { margin:10px 0; }

</style>



// WEBPACK FOOTER //
// website-development.vue?7139c419